import { Icon } from "react-migration/components/Icon";
import { LayerTypeSelectionHeaderProps } from "../../../types";
import { usePropertyInformationByUPRN } from "./usePropertyInformationByUPRN";

export function UKPropertyInformationSelectionHeader({ selection }: LayerTypeSelectionHeaderProps) {
  const { data } = usePropertyInformationByUPRN(selection?.id);

  const { uprn, full_address } = data?.propertyInformationByUPRN.address || {};

  return (
    <div className="flex flex-row items-start gap-x-2">
      <Icon icon="icon-lt-community-line" size="lg" extraClasses="align-text-top" />
      <div className="flex flex-col items-stretch grow">
        <div className="text-xs font-semibold uppercase text-text-base-tertiary">Property</div>
        <div className="text-sm font-semibold text-text-base-primary">{full_address || uprn}</div>
      </div>
    </div>
  );
}
